$(document).ready(function(){
  function checkpage_sidebar(){
    if($('.gift-guide-sidebar-wrp').length > 0){
      $('html').addClass('gift-guide-page-template');
    }else{
      $('html').removeClass('gift-guide-page-template');
      setTimeout(function(){
        checkpage_sidebar();
      },1000);
    }
  }
   $(window).on('load', function() {
     if($('body').hasClass('template-page')){
      checkpage_sidebar();     
     }
  console.log('******');
  });
  if($('body').hasClass('template-page')){
  checkpage_sidebar();
  }
});
